<template>
  <vx-card>
    <vs-input
      class="w-full mb-4"
      v-validate="'required|min:6'"
      data-vv-validate-on="blur"
      label="Заголовок новости"
      name="Заголовок новости"
      v-model="newNews.title"
    />
    <span class="text-danger text-sm">{{
      errors.first("Заголовок новости")
    }}</span>

    <quill-editor
      name="Измененное описание"
      data-vv-validate-on="blur"
      v-validate="'required'"
      v-model="newNews.body"
      :options="editorOption"
    />
    <span class="text-danger text-sm">{{
      errors.first("Измененное описание")
    }}</span>

    <picture-input
      ref="pictureInput"
      class="mt-10 z-10"
      @change="onChange"
      name="Изображение новости"
      width="200"
      height="200"
      margin="1"
      accept="image/jpeg,image/png"
      size="15"
      buttonClass="vs-component vs-button vs-con-loading__container vs-button-primary vs-button-relief"
      :prefill="newNews.image"
      :customStrings="{
        upload: '<h1>Загрузить изображение</h1>',
        drag: 'Загрузите изображение',
        change: 'Изменить изображение',
        remove: 'Удалить изображение',
        select: 'Выбрать изображение',
      }"
    >
    </picture-input>
    <span class="text-danger text-sm">{{
      errors.first("Изображение новости")
    }}</span>

    <vs-button
      @click="createNews"
      :disabled="!validateForm"
      class="mr-5 vs-con-loading__container"
      ref="loadableButton"
      type="relief"
      vslor="primary"
    >
      Создать
    </vs-button>
  </vx-card>
</template>

<script>
import PictureInput from "vue-picture-input";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  data: () => ({
    newNews: {
      title: "",
      body: "",
      image: "",
    },
    editorOption: {
      placeholder: "Введите текст",
    },
  }),
  components: {
    PictureInput,
    quillEditor,
  },
  watch: {},
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.newNews.title !== "" &&
        this.newNews.body !== "" &&
        this.newNews.image !== ""
      );
    },
  },
  methods: {
    onChange() {
      this.newNews.image = this.$refs.pictureInput.file;
    },
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    createNews() {
      this.$load(async () => {
        let res = await this.$api.news.createNewNews(this.newNews);

        if (res.status == 200) {
          let idNewNews = res.data.id;

          let payload = {
            imageFile: this.newNews.image,
          };

          this.$load(async () => {
            await this.$api.news
              .updateNewsImage(idNewNews, payload)
              .then((response) => {
                if (response.status == 200) {
                  this.notification("Успешно", "Новость создана", "success");
                } else {
                  this.notification(
                    "Предупреждение",
                    "Новость создана, но изображение не удалось прикрепить",
                    "warning"
                  );
                }
              });
          });

          this.$router.push({ name: "news" });
        } else {
          this.notification("Ошибка", "Не удалось создать новость", "danger");
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>